import { ADD_ALBUM } from '../actionTypes'

export const addAlbum = (data: object) => ({
  type: ADD_ALBUM.name,
  api: {
    url: 'albums/add',
    data,
  },
})
